// src/services/eventService.js
import api from './api';

export const eventService = {
  async getEvents() {
    const response = await api.get('/events/');
    return response.data;
  },

  async getActiveEvents() {
    const response = await api.get('/events/', { params: { status: 'active' } });
    return response.data;
  },

  // 테넌트 사이트(/o/:slug) 용 — 그 조직의 활성 이벤트만
  async getEventsByOrgSlug(orgSlug) {
    const response = await api.get('/events/', { params: { org_slug: orgSlug } });
    return response.data;
  },

  async getAllEvents(status = null) {
    const params = status ? { status } : {};
    const response = await api.get('/events/all', { params });
    return response.data;
  },

  async getEvent(slug) {
    const response = await api.get(`/events/${slug}`);
    return response.data;
  },

  async getEventById(id) {
    const response = await api.get(`/events/by-id/${id}`);
    return response.data;
  },

  async createEvent(data) {
    const response = await api.post('/events', data);
    return response.data;
  },

  async updateEvent(id, data) {
    const response = await api.put(`/events/${id}`, data);
    return response.data;
  },

  async deleteEvent(id) {
    const response = await api.delete(`/events/${id}`);
    return response.data;
  },

  async activateEvent(id) {
    const response = await api.post(`/events/${id}/activate`);
    return response.data;
  },

  async deactivateEvent(id) {
    const response = await api.post(`/events/${id}/deactivate`);
    return response.data;
  },

  async getLandingPage(slug) {
    const response = await api.get(`/events/${slug}/landing`);
    return response.data;
  },

  async updateLandingPage(eventId, config) {
    const response = await api.patch(`/events/${eventId}/landing-page`, config);
    return response.data;
  },

  async getPaymentConfig(eventId) {
    const response = await api.get(`/events/by-id/${eventId}/payment-config`);
    return response.data;
  },
};
